import React from 'react';
import NostoCategory from './Category';
const FlightNostoCategory = ({ category, route }) => {
    if (category.name !== '' && route && route.path) {
        const data = {
            category: route.path
        };
        return React.createElement(NostoCategory, { data: data, promise: null });
    }
    else
        return null;
};
export default FlightNostoCategory;
//# sourceMappingURL=FlightNostoCategory.js.map